<script setup lang="ts">
import { SbList, SbListItem, SbListSection, SbListLabel } from "@unio/saltbox-ui"

import { ICON } from "@/lib/icons"
import { itemPath } from "@/routes"

defineProps<{
  items: { id: string; name: string; thumb_url: string | null }[]
  editable?: boolean
}>()

const emit = defineEmits<{
  unlink: [itemId: string]
}>()
</script>

<template>
  <SbList separator>
    <SbListLabel header>Linked Items</SbListLabel>
    <SbListItem v-for="item in items" :key="item.id" clickable :to="itemPath(item.id)">
      <SbListSection avatar>
        <UAvatar
          :src="item.thumb_url ?? undefined"
          :alt="item.name"
          size="sm"
          :ui="{ image: 'object-cover' }"
        />
      </SbListSection>
      <SbListSection>
        <SbListLabel :lines="1">{{ item.name }}</SbListLabel>
      </SbListSection>
      <SbListSection v-if="editable" side>
        <UButton
          :icon="ICON.delete"
          size="xs"
          color="error"
          variant="ghost"
          square
          title="Remove link"
          @click.prevent="emit('unlink', item.id)"
        />
      </SbListSection>
    </SbListItem>
  </SbList>
</template>
